declare const __GIT_BRANCH__: string;
declare const __GIT_COMMIT__: string;

export const apiRoute = import.meta.env.VITE_API_URL;
export const envName = import.meta.env.MODE;
export const clvVersion = import.meta.env.VITE_APP_VERSION;
export const devTools = import.meta.env.VITE_DEV_TOOLS === "true";
export const gitBranch = __GIT_BRANCH__;
export const gitCommit = __GIT_COMMIT__;
